export default function recodeTelNumber(tel: string) {
  return tel?.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')
}
